module.exports = __webpack_public_path__ + "img/d6562d0d74d10958c8d4f7f6f111b347.521e0de7.jpg";